"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplorePage = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const translation_hooks_1 = require("@hooks/translation.hooks");
require("./styles.scss");
const tabs_1 = require("@shared-modules/components/tabs");
const token_explorer_page_1 = __importDefault(require("@pages/token-explorer-page"));
const collections_explorer_page_1 = __importDefault(require("@pages/collections-explorer-page"));
const lottery_page_1 = __importDefault(require("@pages/lottery-page"));
const getExplorerTabs = (translator) => [
    {
        label: translator("tokensTab"),
        id: "tokens",
    },
    {
        label: translator("lotteriesTab"),
        id: "lotteries",
    },
    {
        label: translator("collectionsTab"),
        id: "collections",
    },
];
const ExplorePage = (props) => {
    const { params: { tab = "tokens" }, } = (0, react_router_dom_1.useRouteMatch)();
    const history = (0, react_router_dom_1.useHistory)();
    const [activeTab, setActiveTab] = (0, react_1.useState)(tab);
    (0, react_1.useEffect)(() => {
        setActiveTab(tab);
    }, [tab]);
    const setActiveTabHandler = (tab) => {
        setActiveTab(tab);
        history.push(`/explore/${tab}`);
    };
    const translator = (0, translation_hooks_1.usePagesTranslation)("explorePage");
    return (react_1.default.createElement("div", { className: "p-explorer-page" },
        react_1.default.createElement("div", { className: "p-explorer-page__tabs" },
            react_1.default.createElement(tabs_1.Tabs, { tabs: getExplorerTabs(translator), selectedTabId: activeTab, selectTab: setActiveTabHandler })),
        react_1.default.createElement("div", { className: "p-explorer-page__page" },
            activeTab === "tokens" && react_1.default.createElement(token_explorer_page_1.default, null),
            activeTab === "collections" && react_1.default.createElement(collections_explorer_page_1.default, null),
            activeTab === "lotteries" && react_1.default.createElement(lottery_page_1.default, null))));
};
exports.ExplorePage = ExplorePage;
exports.default = exports.ExplorePage;
